export default {"src":"/_next/static/media/hanging-light.8d639524.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};